import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-instagram-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-instagram-svg-icon.component.html',
  styleUrl: './ln-instagram-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnInstagramSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#372121';
}
